module.exports = __webpack_public_path__ + "assets/img/qrcode@2x.81e5402d.png";